import { FC, useEffect, useRef, useState } from 'react'
import { Mousewheel, Swiper as SwiperType } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { IconClose } from 'components/icons/close-icon'
import { CloseButton, Item, List, Name, PeopleContainer } from './styled'
import { variants } from './variants'
import { useDataContext } from 'context/data-context'
import { Link } from 'react-router-dom'

type Props = {
  visibleName: string
  onClose: () => void
}

export const PeopleList: FC<Props> = ({ onClose, visibleName }) => {
  const [init, setInit] = useState(false)
  const swiper = useRef<SwiperType>()
  const { people } = useDataContext()

  useEffect(() => {
    if (visibleName && init) {
      swiper.current?.slideTo(
        people.findIndex(
          p =>
            p.name === visibleName ||
            (p.shortName && p.shortName === visibleName)
        )
      )
    }
  }, [visibleName, init])

  return (
    <PeopleContainer
      variants={variants}
      initial="initial"
      animate="enter"
      exit="exit"
    >
      <CloseButton onClick={onClose}>
        <IconClose />
      </CloseButton>
      <List as="div">
        <Swiper
          onInit={s => {
            swiper.current = s
            setInit(true)
          }}
          modules={[Mousewheel]}
          direction="vertical"
          mousewheel
          centeredSlides
          slidesPerView="auto"
        >
          {people.map(person => (
            <SwiperSlide key={person.name}>
              <Item>
                <Name>{person.name}</Name>
                {person.description} (
                {person.years.map((year, i) => (
                  <>
                    <Link to={`/year/${year}`} key={year}>
                      {year}
                    </Link>
                    {i < person.years.length - 1 && ', '}
                  </>
                ))}
                )
              </Item>
            </SwiperSlide>
          ))}
        </Swiper>
      </List>
    </PeopleContainer>
  )
}
